import { render, staticRenderFns } from "./JobTitle.vue?vue&type=template&id=36534b31&scoped=true&"
import script from "./JobTitle.vue?vue&type=script&lang=js&"
export * from "./JobTitle.vue?vue&type=script&lang=js&"
import style0 from "./JobTitle.vue?vue&type=style&index=0&id=36534b31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36534b31",
  null
  
)

export default component.exports